<template>
  <div class="vs-prompt-form">
    <p class="mb-5">The printer proxy runs on the same computer as the Dymo Label Writer Web Service and allows you to share this printer with all devices running Time Cloud Safe on Site.</p>
    
    <p class="font-semibold">Dymo Label Printer Drivers</p>
    <p><a href="https://download.dymo.com/dymo/Software/Mac/DLS8Setup.8.7.4.dmg" download>Download for Mac OSX</a></p>
    <p><a href="#" @click.prevent="handleDownloadDrivers">Download for Windows</a></p>
    
    <p class="font-semibold mt-5">Time Cloud Printer Proxy</p>
    <p><a href="https://assets.safeonsite.co/downloads/printer-proxy/osx/timecloud-printer-proxy" download>Download for Mac OSX</a></p>
    <p><a href="#" @click.prevent="handleDownloadProxy">Download for Windows</a></p>

    <p class="my-4">After installing the Dymo drivers download the printer proxy and from a command prompt/terminal type</p>

    <pre>timecloud-printer-proxy install {{data.proxyKey}}</pre>
  </div>
</template>

<script>
export default {
  name: 'SetupPrinter',
  props: ['data'],
  data () {
    return {};
  },
  methods: {
    handleDownloadDrivers () {
      window.open('https://download.dymo.com/dymo/Software/Win/DLS8Setup.8.5.0.exe', 'Download')
    },
    handleDownloadProxy () {
      window.open('https://assets.safeonsite.co/downloads/printer-proxy/windows/timecloud-printer-proxy.exe', 'Download')
    }
  },
  mounted () { }
};
</script>